import { WSContainer, WSMessageBox } from "@wingspanhq/fe-component-library";
import axios, { AxiosError } from "axios";
import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { OverlaySpinner } from "../../../components/OverlaySpinner";
import { useWSQuery } from "../../../query/helpers";

export const PATH_GUEST_PAY_LINK = "/payment/invoice";

const QUERY_PAYER_INVOICE_VIEW = "QUERY_PAYER_INVOICE_VIEW";

type PayerInvoiceView = { id: string };

const getPayerInvoiceView = async (viewToken: string) => {
  const response = await axios.get<PayerInvoiceView>(
    `${process.env.REACT_APP_API_URL}/v3/payments/payer-invoice-view/${encodeURIComponent(viewToken)}`
  );
  return response.data;
};

// V3 invoice emails link to /payment/invoice#v=<viewToken>&s=<linkSecret>.
// TODO: remove once the v3 client payment experience serves these links.
export const RouteGuestPayLink: React.FC = () => {
  const location = useLocation();
  const viewToken = new URLSearchParams(location.hash.slice(1)).get("v") ?? "";

  const payerInvoiceViewQuery = useWSQuery<PayerInvoiceView, AxiosError>(
    [QUERY_PAYER_INVOICE_VIEW, viewToken],
    () => getPayerInvoiceView(viewToken),
    { enabled: !!viewToken, retry: false, refetchOnMount: false }
  );

  if (payerInvoiceViewQuery.data) {
    return <Redirect to={`/payment/${payerInvoiceViewQuery.data.id}`} />;
  }

  if (viewToken && payerInvoiceViewQuery.isLoading) {
    return <OverlaySpinner />;
  }

  const isUnknownLink =
    !viewToken ||
    [404, 422].includes(payerInvoiceViewQuery.error?.response?.status ?? 0);

  return (
    <WSContainer verticalPadding>
      <WSMessageBox.Error>
        {isUnknownLink
          ? "No such invoice found"
          : "Sorry, something went wrong"}
      </WSMessageBox.Error>
    </WSContainer>
  );
};
